var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          attrs: { layout: _vm.layout, model: _vm.form, rules: _vm.rules },
        },
        [
          _c(
            "a-form-model-item",
            { attrs: { label: "试题内容：", prop: "topic" } },
            [
              _c("a-input", {
                attrs: { type: "textarea" },
                model: {
                  value: _vm.form.topic,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "topic", $$v)
                  },
                  expression: "form.topic",
                },
              }),
            ],
            1
          ),
          _c(
            "a-form-model-item",
            { attrs: { label: "关联项：", prop: "relevance" } },
            [
              _c("a-select", {
                attrs: {
                  mode: "multiple",
                  placeholder: "请选择关联项",
                  options: _vm.relevanceOptions,
                },
                model: {
                  value: _vm.form.relevance,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "relevance", $$v)
                  },
                  expression: "form.relevance",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }